module.exports = __webpack_public_path__ + "img/qrcode-wx.3ad1417e.jpg";